import Api from "../base/index.js";

export default {
  async all(id) {
    return Api.get(`teacher-subject-by-section-standard/${id}`);
  },
};
